import { SET_PROJECTS, SET_PROJECT, SET_BACKEND_SERVICE, SET_FRONTEND_APP, SET_CURRENT_REDIS_CLUSTER, ADD_DATABASE, UPDATE_DATABASE, DELETE_DATABASE, GET_DATABASE, ADD_PROJECT, DELETE_PROJECT, UPDATE_PROJECT, ADD_BACKEND_SERVICE, ADD_FRONTEND_APP, DELETE_BACKEND_SERVICE, DELETE_BRANCH_FROM_FRONTEND_APP, ADD_BRANCH_TO_FRONTEND_APP } from "../constants/actionTypes";

const initialState = {
  projects: [],
  currentProject: null,
  currentService: null,
  currentFrontendApp: null,
  currentRedisCluster: null,
  currentDatabase: null,
};

const infrastructureReducer = (state = initialState, action) =>{
    switch(action.type){
        case SET_PROJECTS:
          return {
            ...state,
            projects: action.payload || []
          };
        case SET_PROJECT:
          return {
            ...state,
            currentProject: action.payload
          };
        case ADD_BACKEND_SERVICE:
          return {
            ...state,
            currentProject: {
              ...state.currentProject,
              backendServices: [
                ...(state.currentProject?.backendServices || []),
                action.payload
              ]
            }
          }

        case DELETE_BACKEND_SERVICE:
          return {
            ...state,
            currentProject: {
              ...state.currentProject,
              backendServices: (state.currentProject?.backendServices || []).filter(service => service.serviceId !== action.payload)
            }
          }
        case ADD_FRONTEND_APP:
          return {
            ...state,
            currentProject: {
              ...state.currentProject,
              frontendApps: [
                ...(state.currentProject?.frontendApps || []),
                action.payload
              ]
            }
          }
        case SET_BACKEND_SERVICE:
          return {
            ...state,
            currentService: action.payload
          };
        case SET_FRONTEND_APP:
          return {
            ...state,
            currentFrontendApp: action.payload
          };
        case SET_CURRENT_REDIS_CLUSTER:
          return {
            ...state,
            currentRedisCluster: action.payload
          };

        case ADD_DATABASE:
          return {
            ...state,
            currentProject: {
              ...state.currentProject,
              databases : [
                ...(state.currentProject?.databases || []),
                action.payload
              ]
            }
          };
        
        case UPDATE_DATABASE:
          return {
            ...state,
            currentProject: {
              ...state.currentProject,
              databases : (state.currentProject?.databases || []).map(database => database.databaseId === action.payload.databaseId ? action.payload : database)
            }
          };

        case DELETE_DATABASE:
          return {
            ...state,
            currentProject: {
              ...state.currentProject,
              databases : (state.currentProject?.databases || []).filter(database =>  database.databaseId !== action.payload) 
            }
          };
          
        case GET_DATABASE:
          return {
            ...state,
            currentDatabase: action.payload
          };

        case ADD_PROJECT:
          return {
            ...state,
            projects: [...(state.projects || []), action.payload]
          };
        case DELETE_PROJECT:
          return {
            ...state,
            projects: state.projects.filter(
              project => project.projectId !== action.payload
            )
          };

        case UPDATE_PROJECT:
          return {
            ...state,
            projects: state.projects?.map(project =>
              project.projectId === action.payload.projectId ? action.payload : project
            )
          };
        case ADD_BRANCH_TO_FRONTEND_APP:
          return {
            ...state,
            currentFrontendApp: {
              ...state.currentFrontendApp,
              branches: [
                ...(state.currentFrontendApp?.branches || []),
                action.payload
              ]
            }
          };
        case DELETE_BRANCH_FROM_FRONTEND_APP: 
          return {
              ...state,
              currentFrontendApp: {
                ...state.currentFrontendApp,
                branches: state.currentFrontendApp.branches.filter(
                  branch => branch.branchId !== action.payload
                )
              }
          };
        default: 
            return state; 

    }

};

export default infrastructureReducer;